// extracted by mini-css-extract-plugin
export var addButton = "_gw-0";
export var border = "_gw-8";
export var check = "_gw-h";
export var danger = "_gw-6";
export var dropdownContainer = "_gw-1";
export var editModalBody = "_gw-j";
export var footerContainer = "_gw-i";
export var fullWidth = "_gw-a";
export var hide = "_gw-9";
export var icon = "_gw-3";
export var input = "_gw-7";
export var inputFlex = "_gw-b";
export var inputWrapper = "_gw-c";
export var manualFocus = "_gw-5";
export var optionButton = "_gw-4";
export var pillWrapper = "_gw-e";
export var pointer = "_gw-2";
export var showOverflow = "_gw-f";
export var tagsFlex = "_gw-d";
export var xButton = "_gw-g";